import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isSubscribedReq } from '../services/hpoolService';
import { divideOnWei } from '../utils/mapper';
import { usePromise } from './usePromise/usePromise';

export const useIsSubscribed = (poolId) => {
  const account = useSelector((state) => state.wallet?.account);
  const [subscribtionAmount, setSubscribtionAmount] = useState(0);
  const [isWithdrawn, setIsWithdrawn] = useState(false);
  const [ownedTickets, setOwnedTickets] = useState(0);

  const onSuccess = (isSubscribedRes) => {
    if (!isSubscribedRes) return;
    let subscribtionAmount = divideOnWei(isSubscribedRes?.[0]) || 0;
    subscribtionAmount = subscribtionAmount.toFixed(2) || 0;
    const _ownedTickets = isSubscribedRes?.[1];
    const _isWithdrawn = isSubscribedRes?.[2];
    setIsWithdrawn(_isWithdrawn);
    setOwnedTickets(_ownedTickets);
    setSubscribtionAmount(subscribtionAmount);
  };

  const [getIsSubscribedReq, isSubscribedRes] = usePromise(isSubscribedReq, { onSuccess });
  const isSubscribed = subscribtionAmount > 0 && !isWithdrawn;

  const refreshInfo = () => {
    getIsSubscribedReq(poolId, account);
  };

  useEffect(() => {
    if (!Number.isInteger(+poolId) || !account) return;
    refreshInfo();
  }, [poolId, account]);

  return [isSubscribed, subscribtionAmount, ownedTickets, getIsSubscribedReq, refreshInfo];
};
